import "core-js/modules/es.number.constructor.js";
import debounce from "lodash/debounce";
import { computed, defineComponent, toRefs, reactive, ref, onMounted, watch } from "vue";
export default defineComponent({
  name: "volumeProgress",
  props: {
    /** 进度条的宽度 */
    width: {
      type: Number,
      default: 4
    },

    /** 外层进度条的背景颜色 */
    outColor: {
      type: String,
      default: "#e5e5e5"
    },

    /** 外层进度条的背景颜色 */
    color: {
      type: String,
      default: "#d33a30"
    },

    /** 进度条的百分比 */
    percentage: {
      type: Number,
      default: 60
    },

    /** 进度条是否展示 */
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change-progress"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _toRefs = toRefs(props),
        width = _toRefs.width,
        outColor = _toRefs.outColor,
        color = _toRefs.color,
        percentage = _toRefs.percentage,
        visible = _toRefs.visible;

    var progressRef = ref();
    /** 进度条元素 */

    var dragState = reactive({
      innerPercentage: percentage.value,
      dragging: false
      /** 是否正在拖拽进度条 */
      ,
      startY: 0
      /** 记录最开始点击的Y轴坐标 */

    });
    var outerStyle = computed(function () {
      return {
        width: "".concat(width.value, "px"),
        "background-color": outColor.value,
        "border-radius": "".concat(width.value / 2, "px")
      };
    });
    var innerWrapperStyle = computed(function () {
      return {
        height: "".concat(dragState.innerPercentage, "%")
      };
    });
    var innerStyle = computed(function () {
      return {
        height: "100%",
        "background-color": color.value,
        "border-radius": "".concat(width.value / 2, "px")
      };
    });
    var percentageStyle = computed(function () {
      return {
        "background-color": color.value,
        bottom: "calc(".concat(dragState.innerPercentage, "% - 5px)")
      };
    });
    var handleProgressChange = debounce(function () {
      var _progressRef$value;

      var endY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      /** 获取进度条到浏览器的距离 */
      var eleToTop = ((_progressRef$value = progressRef.value) === null || _progressRef$value === void 0 ? void 0 : _progressRef$value.getBoundingClientRect().top) || dragState.startY;
      /** 计算鼠标距离进度条底部的百分比 */

      var percent = (80 - (endY - eleToTop)) / 80 * 100;

      if (percent > 100) {
        percent = 100;
      } else if (percent < 0) {
        percent = 0;
      }

      dragState.innerPercentage = percent;
      emit("change-progress", percent);
    }, 10);

    var handleDragStart = function handleDragStart(e) {
      var _progressRef$value2, _progressRef$value3;

      dragState.dragging = true;

      if (e instanceof TouchEvent) {
        dragState.startY = e.changedTouches[0].clientY;
      } else {
        dragState.startY = e.clientY;
      }

      handleProgressChange(dragState.startY); // 为元素添加鼠标移动和松开事件

      (_progressRef$value2 = progressRef.value) === null || _progressRef$value2 === void 0 ? void 0 : _progressRef$value2.addEventListener("mousemove", moveHandler);
      (_progressRef$value3 = progressRef.value) === null || _progressRef$value3 === void 0 ? void 0 : _progressRef$value3.addEventListener("mouseup", moveHandler);
    };

    var handleOnDrag = function handleOnDrag(e) {
      if (!dragState.dragging) {
        return false;
      }
      /** 获取进度条到浏览器的距离 */


      var endY = 0;

      if (e instanceof TouchEvent) {
        endY = e.changedTouches[0].clientY;
      } else {
        endY = e.clientY;
      }

      handleProgressChange(endY);
    };

    var moveHandler = function moveHandler(e) {
      if (e.type === "mousedown" || e.type === "touchstart") {
        handleDragStart(e);
      } else if (e.type === "mousemove" || e.type === "touchmove") {
        handleOnDrag(e);
      } else if (e.type === "mouseup" || e.type === "touchend") {
        var _progressRef$value4;

        dragState.dragging = false;
        (_progressRef$value4 = progressRef.value) === null || _progressRef$value4 === void 0 ? void 0 : _progressRef$value4.removeEventListener("mousemove", moveHandler);
      }
    };

    watch(visible, function (val) {
      /** 组件不显示的时候，设置dragging为false */
      if (!val) {
        dragState.dragging = false;
      }
    });
    onMounted(function () {
      var _progressRef$value5;

      (_progressRef$value5 = progressRef.value) === null || _progressRef$value5 === void 0 ? void 0 : _progressRef$value5.addEventListener("mousedown", moveHandler);
    });
    return {
      progressRef: progressRef,
      outerStyle: outerStyle,
      innerWrapperStyle: innerWrapperStyle,
      innerStyle: innerStyle,
      percentageStyle: percentageStyle,
      handleDragStart: handleDragStart,
      handleOnDrag: handleOnDrag
    };
  }
});